// import components
import { useState } from "react";
export const useToggleButtonGroup = ({ selectedSubItemId, subItems } = {}) => {
    const [value, setValue] = useState(String(selectedSubItemId ?? 0));
    return {
        value,
        toggleButtonChangeHandler: (event, newValue) => {
            if (value !== newValue) {
                setValue(newValue);
                const selectedItem = subItems?.find((f) => f.value === newValue);
                selectedItem?.payload?.();
            }
        },
    };
};
export default useToggleButtonGroup;
